import styled from 'styled-components';

import { DawnArrowDown } from '@xemplo/icons';
import {
  fieldVariables,
  inputBaseStyles,
  inputContainerBaseStyles,
  inputFocus,
  inputLabelBaseStyles,
  InputSize,
} from '@xemplo/input-utils';
import { Body2XSmallSemiBold, BodyXSmallSemiBold } from '@xemplo/style-constants';

export const Wrapper = styled.div`
  ${fieldVariables};
  width: var(--input-width);
`;

export const Container = styled.div`
  ${inputContainerBaseStyles};

  &.open:not(.invalid) {
    ${inputFocus};
  }

  &.${InputSize.Compact} {
    padding: 9px 16px;
  }
`;

export const Label = styled.label`
  ${inputLabelBaseStyles};

  &.${InputSize.Spacious} {
    &:is(.has-placeholder, .has-value) {
      ${BodyXSmallSemiBold};
      top: 10px;
    }
  }

  &.${InputSize.Default} {
    ${Body2XSmallSemiBold};
    top: 3px;
  }
`;

export const Select = styled.div`
  ${inputBaseStyles};
  display: flex;
  align-items: flex-end;
  overflow: hidden;

  &.${InputSize.Default} {
    &:is(.open, .has-placeholder, .has-value) {
      &.has-label {
        margin-bottom: -6px;
      }
    }
  }

  &.${InputSize.Compact} {
    align-items: center;
  }
`;

export const Placeholder = styled.span`
  color: var(--input-placeholder-text-color);
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  width: 16px;
  height: 24px;
  padding: 4px 0;
  color: var(--input-trailing-icon-color);
  cursor: pointer;
`;

export const ArrowIcon = styled(DawnArrowDown)`
  transition: transform 0.1s ease-out;
  &.open {
    transform: rotate(180deg);
  }
`;
